module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"next":"Weiterlesen"},"en":{"next":"Read next"},"it":{"next":""},"lt":{"next":"Kitas įrašas"},"pl":{"next":"Czytaj następny"}}')
  delete Component.options._Ctor
}
